import styled, { css } from 'styled-components'
import { Text, Icon } from '@/ui'
import Anchor from '@/ui/Anchor'

//MAIN DROPDOWN
export const DropdownWrapper = styled.div<{
  disabled?: boolean
  noMargin?: boolean
}>`
  ${({ disabled, noMargin }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    margin: ${noMargin ? '' : '0 0 1em'};
    pointer-events: ${disabled ? 'none' : 'auto'};
    opacity: ${disabled ? '0.7' : '1'};
  `}
`
export const InputAndSelectionContainer = styled.div<{
  error?: boolean
  disabled?: boolean
  open?: boolean
  oneline?: boolean
}>`
  ${({ error, open, oneline }) => css`
    display: flex;
    align-items: center;
    flex-wrap: ${oneline ? 'nowrap' : 'wrap'};
    width: 100%;
    min-height: ${oneline ? '35px' : '35px'};
    max-height: ${oneline ? '35px' : '114px'};
    overflow-y: auto;
    background: #fff;
    padding: 2px;
    border: ${error ? '1px solid #de5447 !important' : '1px solid #bdcbd0'};
    border-radius: 4px;
    cursor: text;
    &&& {
      .test {
        border: none !important;
        outline: none !important;
        width: auto;
      }
    }
    > i {
      transform: ${open ? 'rotate(180deg)' : 'none'};

      top: ${open && oneline
        ? '9px'
        : !open && oneline
        ? '7px'
        : open
        ? '20px'
        : '16px'};
    }
  `}
`

export const Input = styled.input<{
  oneline?: boolean
}>`
  ${({ oneline }) => css`
    height: ${oneline ? '24px' : '35px'};
    border-radius: 4px;
    border: none !important;
    outline: none !important;
    background: #fff !important;
  `}
`
export const AngleDownIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-angle-down',
})`
  &&& {
    font-size: 20px !important;
    position: absolute;
    right: 12px;
    margin-right: 0;
  }
`
export const DropdownBox = styled.div<{
  upward?: boolean
  oneline?: boolean
  height?: number
}>`
  ${({ upward, oneline, height }) => css`
    position: absolute;
    z-index: 10;
    width: 100%;
    max-height: 320px;
    /*top: ${upward ? '-321px;' : oneline ? '40px' : '60px'};*/
    top: ${oneline ? '40px' : upward ? 'unset' : height + 'px'};
    bottom: ${upward ? height + 'px' : 'unset'};
    overflow-y: scroll;
    border-radius: 4px;
    background: white;
    border: 1px solid var(--neutral-gray-300, #e6e8eb);
  `}
`
//DEPARTMENT ROW

//ParentDepartmentRow

export const ParentText = styled.span<{
  isDisabled: boolean
}>`
  ${({ isDisabled }) => css`
    display: flex;
    cursor: pointer !important;
    opacity: ${isDisabled ? '0.5' : '1'};
  `}
`
export const ParentTextWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
export const ParentRow = styled.div<{
  isHovering: boolean
  selected: boolean
}>`
  ${({ isHovering, selected }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    width: 100%;
    padding: 16px;
    border-bottom: 1px solid var(--color-gray-gray-200, #f3f3f5);
    background: var(--color-gray-gray-50, #fcfcfc);
    border: ${isHovering ? '1px solid #6d87f4' : 'none'};
    background: ${selected
      ? `var(
      --primary-primary-100,
      linear-gradient(
        0deg,
        rgba(42, 94, 246, 0.05) 0%,
        rgba(42, 94, 246, 0.05) 100%
      ),
      #fff
    )`
      : 'var(--color-gray-gray-50, #fcfcfc)'};

    &:hover {
      background: var(
        --primary-primary-100,
        linear-gradient(
          0deg,
          rgba(42, 94, 246, 0.05) 0%,
          rgba(42, 94, 246, 0.05) 100%
        ),
        #fff
      );
    }
  `}
`
export const ParentRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`
export const ParentClickContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  margin-left: 16px;
`
export const FirstChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 0px 10px 0px;
`
//ChildDepartmentRow
export const ChildRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  z-index: 1;
  cursor: pointer;
`
export const ChildRowText = styled.span<{
  isDisabled: boolean
}>`
  ${({ isDisabled }) => css`
    display: flex;
    opacity: ${isDisabled ? '0.5' : '1'};
  `}
`
export const ChildRowContent = styled.div<{
  selected: boolean
  matchedSearch: boolean
  isHovering: boolean
}>`
  ${({ selected, matchedSearch, isHovering }) => css`
    display: flex;
    align-items: center;
    padding: 5px 0px;
    gap: 8px;
    width: 100%;
    cursor: pointer;
    background: ${matchedSearch
      ? '#ebeffd'
      : selected
      ? 'var(--primary-primary-100, linear-gradient(0deg, rgba(42, 94, 246, 0.05) 0%, rgba(42, 94, 246, 0.05) 100%), #FFF); '
      : 'inherit'};
    border: ${isHovering ? '1px solid #6d87f4' : 'none'};
    border-radius: 4px;
    &:hover {
      background: var(
        --primary-primary-100,
        linear-gradient(
          0deg,
          rgba(42, 94, 246, 0.05) 0%,
          rgba(42, 94, 246, 0.05) 100%
        ),
        #fff
      );
    }
  `}
`

export const ArrowIconContainer = styled.div<{
  open: boolean
}>`
  ${({ open }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 19px;
    padding: 5px;
    transition: transform 0.1s ease-in-out;
    transform: ${open ? 'none' : 'rotate(-90deg)'};
  `}
`
export const CheckboxAligner = styled.div``

export const CheckAnchor = styled(Anchor)`
  ${({ theme, disabled }) => css`
    display: block;
    cursor: ${!disabled ? 'pointer' : 'default'};
    color: ${theme.primaryColor};
  `}
`

//SELECTED DEPARTMENT

export const SelectedDepartmentWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 34px;
  margin: 4px;
  cursor: pointer;
  padding: 7px 0px 7px 7px;
  background: #f5f7f8;
  border-radius: 4px;
  line-height: 1.3;
`
export const PathAndName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`

export const SelectedDepartmentPathContainer = styled.div`
  display: flex;
  container-type: inline-size;
`
export const Path = styled.span`
  font-size: 8px;
  opacity: 0.8;
  color: #525b75;
  font-weight: 1000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SelectedDepartmentName = styled.span`
  font-size: 11px;
  font-weight: 1000;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`

export const SmallSlectionContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 70%;
  padding: 2px;
  margin-left: 12px;
  border-radius: 4px;
  cursor: auto;
`
//@ts-ignore
export const SmallSelectionText = styled(Text.Span).attrs({
  grey: true,
})`
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
